import {
  RoiChartView,
  RoiDataRespTimeLineView,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { AnalyticsUtils } from '@frontend/analytics-shared';

// Translations not required for demo data
const conversionTypes: string[] = ['Same Day', '7 Days', '14 Days', '21 Days', '28 Days'];
const weeks = ['Jan 1-Jan 7', 'Jan 8-Jan 14', 'Jan 15-Jan 21', 'Jan 22-Jan 28', 'Jan 29-Jan 31'];

export const detailedConversionCategorized: RoiChartView = {
  data: conversionTypes.map((conversionType, index) => {
    const start = 5;

    return {
      conversionType,
      count: start + index * 3,
    };
  }),
  message: '',
};

export const detailedConversionTimeline: RoiDataRespTimeLineView = {
  data: {
    conversionDetails: conversionTypes.map((conversionType) => ({
      conversionType,
      data: weeks.map((name) => ({
        name,
        count: AnalyticsUtils.demoDataUtils.generateRandomInt(0, 10),
      })),
    })),
  },
  message: '',
};
